export default __webpack_public_path__ + "static/media/refresh-arrow.36f1cc05.svg";